import { Component, OnInit } from '@angular/core';
import { UserSettingsService } from 'src/app/shared/services/user-settings.service';
import { CHANNELS } from '../channels.constant';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppConfig } from 'src/app/app-config';
import { ActivatedRoute } from '@angular/router';
import { CitywireInternalAccountsService } from '@tpapa/citywire-internal-accounts-angular';
import { map, switchMap, take } from 'rxjs';

@Component({
  selector: 'app-reporting-dashboard',
  templateUrl: './reporting-dashboard.component.html',
})
export class ReportingDashboardComponent implements OnInit {
  channels = CHANNELS;
  audienceContentUrl: SafeResourceUrl;
  tagEngagementUrl: SafeResourceUrl;
  fundOfFundsUrl: SafeResourceUrl;
  topManagersUrl: SafeResourceUrl;
  emailActivityUrl: SafeResourceUrl;
  selectedReportIndex: number;
  constructor(
    private userSettingsService: UserSettingsService,
    private accountsService: CitywireInternalAccountsService,
    private sanitizer: DomSanitizer,
    private appConfig: AppConfig,
    private activatedRoute: ActivatedRoute
  ) {
    this.audienceContentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.appConfig.audienceContentUrl
    );
    this.tagEngagementUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.appConfig.tagEngagementUrl
    );
    this.fundOfFundsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.appConfig.fundOfFundsUrl
    );
    this.topManagersUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.appConfig.topManagersUrl
    );
    this.emailActivityUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.appConfig.emailActivityUrl
    );
  }

  ngOnInit() {
    this.selectedReportIndex = this.activatedRoute.snapshot.data.tabIndex;
    this.initializeReports();
  }

  async initializeReports(): Promise<void> {
    const currentUserName = await this.accountsService.currentUser
      .pipe(
        take(1),
        map((user) => user.username)
      )
      .toPromise();
    await this.userSettingsService.getByUserName$(currentUserName).toPromise();
  }
}
